import { PlanWebEntity } from './../../../plans/plans-web-repository/entities/plan-web-entity';
import { MasterPlan, Plan } from 'planning-portal-library/src/lib/core/domain';
import { Mapper } from '../../../../../core/base';
import { PlanWebRepositoryMapper } from '../../../plans/plans-web-repository/entities/plan-web-repository-mapper';
import { MasterPlanWebEntity } from './master-plan-web-entity';
import { DistributionTypes } from 'planning-portal-library/src/lib/core/domain/enums';

export class MasterPlanWebRepositoryMapper extends Mapper<
  MasterPlanWebEntity,
  MasterPlan
> {
  constructor() {
    super();
  }

  mapFrom(param: MasterPlanWebEntity): MasterPlan {
    const planList: Plan[] = [];
    const planMapper = new PlanWebRepositoryMapper();
    param.plans?.forEach((plan) => {
      const mappedPlan = planMapper.mapFrom(plan);
      planList.push(mappedPlan);
    });
    return {
      id: param.id,
      name: param.name,
      description: param.description,
      distributionLaneName: param.distributionLaneName,
      distributionLaneId : param.distributionLaneId,
      timeZone:param.timeZone,
      offSet:param.offSet,
      organizationUnitId: param.organizationUnitId,
      createdAt: param.createdAt,
      createdBy: param.createdBy,
      modifiedAt: param.modifiedAt,
      plans: planList,
      type:param.type,
      additionalData:param.additionalData
    };
  }

  mapTo(param: MasterPlan): MasterPlanWebEntity {
    const planWebEntityList: PlanWebEntity[] = [];
    const planMapper = new PlanWebRepositoryMapper();
    param.plans?.forEach((plan) => {
      const mappedPlan = planMapper.mapTo(plan);
      planWebEntityList.push(mappedPlan);
    });
    return {
      id: param.id,
      name: param.name,
      description: param.description,
      distributionLaneName: param.distributionLaneName,
      distributionLaneId : param.distributionLaneId,
      timeZone:param.timeZone,
      offSet:param.offSet,
      organizationUnitId: param.organizationUnitId,
      createdAt: param.createdAt,
      createdBy: param.createdBy,
      modifiedAt: param.modifiedAt,
      plans: planWebEntityList,
      type:param.type,
      additionalData:param.additionalData
    };
  }
}
